




































































































































































































































































































































import store from '../../../store'
import { stockCalculations } from '../../../mixins/mixins'
import PageTitle from '../../../components/PageTitle.vue'
import dayjs from 'dayjs'

export default {
  mixins: [stockCalculations],
  data () {
    return {
      name: '',
      date: dayjs().format('YYYY-MM-DD'),
      pasture: '60% dig, 8.2 MJ ME/kg  - Gone to seed',
      pastureItems: [
        '40% dig, 4.8 MJ ME/kg - Dry (Dead)',
        '50% dig, 6.5 MJ ME/kg - Dry, perennial',
        '60% dig, 8.2 MJ ME/kg  - Gone to seed',
        '70% dig, 10 MJ ME/kg - Green, grassy',
        '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover',
        '80% dig - 11.6 MJ ME/kg - Green, 60% clover'
      ],
      urea: {
        perTonne: 0,
        spreading: 0,
        response: null
      },
      gAcid: {
        perTonne: 0,
        spreading: 0,
        response: null
      },
      comparison: {
        feedType: ['Pellets', 'Grain', 'Silage / hay / straw'],
        energy: [12, 13, 9],
        dryMatter: [90, 90, 85],
        utilisation: [90, 80, 70],
        feedCost: 100
      }
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    const stored = store.state.otherTools4
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.urea = stored.urea
      this.gAcid = stored.gAcid
      this.comparison = stored.comparison
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateOtherTools4', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateOtherTools4', this.$data)
  },

  computed: {
    nitrogenPastureME: function (this:any) {
      switch (this.pasture) {
        case '40% dig, 4.8 MJ ME/kg - Dry (Dead)':
          return 4.8
        case '50% dig, 6.5 MJ ME/kg - Dry, perennial':
          return 6.5
        case '60% dig, 8.2 MJ ME/kg  - Gone to seed':
          return 8.2
        case '70% dig, 10 MJ ME/kg - Green, grassy':
          return 10
        case '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover':
          return 10.8
        case '80% dig - 11.6 MJ ME/kg - Green, 60% clover':
          return 11.6
        default:
          return 0
      }
    }
  },

  components: {
    PageTitle
  },

  store
}
